export const UserRole = {
  Admin: 0,
  Editor: 1,
};
/*
Menu Types:
"menu-default", "menu-sub-hidden", "menu-hidden"
*/
export const defaultMenuType = 'menu-default';

export const subHiddenBreakpoint = 1440;
export const menuHiddenBreakpoint = 768;
export const defaultLocale = 'en';
export const localeOptions = [
  { id: 'en', name: 'English', direction: 'ltr' },
  { id: 'th', name: 'ไทย', direction: 'ltr' }, // thai language
];
export const defaultLocaleOptions = [
  { id: 'en', name: 'English', direction: 'ltr' },
];
export const currentUser = {
  id: 1,
  title: 'Jaya Kumar Ganesan',
  img: '/assets/img/profiles/l-1.jpg',
  date: 'Last seen today 15:24',
  role: UserRole.Admin,
};

export const adminRoot = '/app';
export const searchPath = `${adminRoot}/#`;

export const themeColorStorageKey = '__theme_selected_color';
export const isMultiColorActive = true;
export const defaultColor = 'light.purplemonster';
export const isDarkSwitchActive = true;
export const defaultDirection = 'ltr';
export const themeRadiusStorageKey = '__theme_radius';
export const isAuthGuardActive = false;
export const colors = [
  'bluenavy',
  'blueyale',
  'blueolympic',
  'greenmoss',
  'greenlime',
  'purplemonster',
  'orangecarrot',
  'redruby',
  'yellowgranola',
  'greysteel',
];

export const DROPDOWN_OPTION_DEFAULT = {
  value: undefined,
  label: 'All',
};

export const ATTACHMENT_MAX_SIZE = 5242880;

export const ATTACHMENT_FILE_FORMAT = [
  '.png',
  '.jpg',
  '.jpeg',
  '.pdf',
  '.doc',
  '.docx',
  '.xls',
  '.xlsx',
  '.ppt',
  '.pptx',
  '.pdf',
  '.msg',
];

export const MINS_59 = 59;
export const MINS_99 = 99;
export const MAXIMUM_TEXTAREA_LIMIT = 200;
export const POST_OT_HOURS_MINIMUM_VALUE = 0.01;
// eslint-disable-next-line prettier/prettier
export const POST_SDIT_OT_HOURS_MINIMUM_VALUE = 1.00;
export const LEAVE_CLAIM_TYPE_SUPPORTED_OT_VALUES = [4, 8];
